import tierQueries from '@apis/queries/tierQueries';
import TierApi from '@apis/tier/TierApi';
import { GetTierHistoryParams } from '@models/tier';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getNextPageParam } from '@utils/slice';
import { useAtom } from 'jotai';
import { useEffect } from 'react';

import { tierCalculatedDateAtom } from '../atoms/tierAtoms';

function useTierHistory() {
    const [calculatedDate, setCalculatedDate] = useAtom(tierCalculatedDateAtom);
    const params: Omit<GetTierHistoryParams, 'page'> = {
        size: 10,
        calculatedDate,
    };
    const queryInfo = useInfiniteQuery({
        queryKey: tierQueries.history(params).queryKey,
        queryFn: ({ pageParam }) => TierApi.getTierHistory({
            ...params,
            page: pageParam,
        }),
        initialPageParam: 0,
        getNextPageParam: (data) => getNextPageParam(data.records),
    });

    const records = queryInfo.data
        ?.pages.map((it) => it.records.content)
        .flat();
    const accumulationType = queryInfo?.data?.pages?.[0]?.accumulationType;

    const isBlank = queryInfo.isFetched && records?.length === 0;

    useEffect(() => () => setCalculatedDate(undefined), []);

    return {
        ...queryInfo,
        records,
        isBlank,
        accumulationType,
    };
}

export default useTierHistory;
